import { QuickInputTreeRenderer } from './quickInputTreeRenderer.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/**
 * Delegate for QuickInputTree that provides height and template information.
 */
class QuickInputTreeDelegate {
    getHeight(_element) {
        return 22;
    }
    getTemplateId(_element) {
        return QuickInputTreeRenderer.ID;
    }
}

export { QuickInputTreeDelegate };
